export const TOUCH_PLATFORM_TYPES = ['mobile', 'tablet'];
export const MAC_OS_NAME = 'macOS';
export const IPAD_MIN_TOUCH_POINTS = 2;
